// eslint-disable-next-line import/prefer-default-export
export const preventSpecialCharacters = (event) => {
  if (
    event.charCode === 46
    || event.charCode === 190
    || (event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))
  ) {
    event.preventDefault();
    return false;
  }
  return true;
};

export const preventSpecSymbols = (event) => {
  const specialCharacters = /[[\]^()+=!~`\-<>?:;*/|%&{}]/g;
  if (specialCharacters.test(event.key)) {
    event.preventDefault();
    return false;
  }
  return true;
};

export const restrictSpecialCharacters = (event) => {
  var specials = /[^A-Za-z 0-9]/g;
  var key = String.fromCharCode(event.which);
  if (specials.test(key)) {
    event.preventDefault();
    return false;
  }
  return true;
};

export const restrictSpecialCharactersForUserId = (event) => {
  var specials = /[^A-Za-z0-9]/g;
  var key = String.fromCharCode(event.which);
  if (specials.test(key)) {
    event.preventDefault();
    return false;
  }
  return true;
};

export const leadingZeros = (input) => {
  if (!isNaN(input.value) && input.value.length > 0) {
    input.value = input.value.padStart(2, '0');
  }
};

export const checkValueDate = (input) => {
  if (Number(input.value) < 1 || Number(input.value) > 31) {
    input.value = '01';
  }
};

export const checkValueMonth = (input) => {
  if (Number(input.value) < 1 || Number(input.value) > 12) {
    input.value = '01';
  }
};
export const checkValueYear = (input) => {
  if (Number(input.value) > 2020) {
    input.value = '2020';
  }
};
export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.toLowerCase().slice(1);
};

export const getNumberString = (value) => {
  var numb = value.match(/\d/g);
  if (numb) {
    numb = numb.join('');
    return numb;
  }
};

export const scrollToSection = (history) => {
  if (history.location.hash) {
    const elem = document.getElementById(history.location.hash.slice(1));
    const checkHashScroll = history.location.hash.slice(1) === 'other-information' || history.location.hash.slice(1) === 'employment-information' || history.location.hash.slice(1) === 'employer-address' || history.location.hash.slice(1) === 'tax-residency';
    if (elem) {
      setTimeout(() => {
        window.scrollTo({
          top: checkHashScroll ? elem.offsetTop + 100 : elem.offsetTop,
          behavior: 'smooth',
        });
        // elem.scrollIntoView({ behavior: 'smooth'});
      });
    }
  }
};

export const autoFocus = (value, maxLength) => {
  const [fieldName, fieldIndex] = value.name.split('-');
  if (value.value.length >= maxLength) {
    // Check if it's not the last input field
    if (parseInt(fieldIndex, 10) < 3) {
      // Get the next input field
      const nextSibling = document.querySelector(
        `input[name=${fieldName}-${parseInt(fieldIndex, 10) + 1}]`,
      );
      // If found, focus the next field
      if (nextSibling !== null) {
        nextSibling.focus();
      }
    }
  }
};